<template>

  <v-card class="driver-status-selector" style="background-color:#080404">
    <!-- Title -->
    <v-card-title class="text-h5 pb-4" style="border-bottom:1px solid #212121;">Assign Driver</v-card-title>

    <!-- Driver cards -->
    <v-card-text class="px-0 mt-6">
      <v-container fluid v-if="driverItems.length > 0">
        <v-row class="mx-2">
          <v-col
              v-for="(driver, index) in driverItems"
              :key="`driver-${index}`"
              :ref="driver.id"
              :class="{ active: driver.id === selectedDriver.id }"
              cols="6">
            <driver-status-card
                :user="driver"
                v-on:itemClicked="setSelectedDriver(driver)" />
          </v-col>
        </v-row>
      </v-container>

      <v-container v-else>
        (No drivers)
      </v-container>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions class="mt-2 px-6 py-6" style="border-top:1px solid #212121;">
      <v-btn text color="primary" width="90" @click="emitCancel">
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn large color="primary" width="180" :disabled="!selectedDriver.id" @click="emitSelection">
        Assign Driver
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import DriverStatusCard from '@/components/drivers/DriverStatusCard'

export default {
  name: 'DriverStatusSelector',

  components: {
    DriverStatusCard
  },

  props: {
    activeSelected: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      selectedDriver: {}
    }
  },

  computed: {
    driverData () {
      return this.$store.getters['sh/data']('drivers')
    },
    driverItems () {
      return (this.driverData) ? this.driverData.items : []
    }
  },

  async beforeMount () {
    // Ensure all drivers are loaded
    await this.$store.dispatch('sh/dataApi', {
      method: 'load',
      uri: 'drivers',
      opts: {
        resource: 'drivers',
        all: true,
        force: true
      }
    })

    // Set the active selection (if provided)
    if (this.activeSelected) this.selectedDriver = this.activeSelected
  },

  methods: {
    emitCancel () {
      this.selectedDriver = {}
      this.$emit('canceled')
    },

    emitSelection () {
      this.$emit('selected', this.selectedDriver)
    },

    setSelectedDriver (driver) {
      this.selectedDriver = driver
    }
  }
}
</script>

<style>
  .active {
    border-radius: 4px;
    border: 2px solid #c9c9c9;
  }
</style>
